module.exports = __webpack_public_path__ + "static/media/form.01dec4af.svg";